import { render } from "./UnverifiedEmail.vue?vue&type=template&id=015e5635"
import script from "./UnverifiedEmail.vue?vue&type=script&lang=js"
export * from "./UnverifiedEmail.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__